export default __webpack_public_path__ + "static/media/suitenupcias_2.6e524946.jpg";